import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { Celebration } from '../../../uiKit/assets/svg/celebration.js'
import Feedback from '../../../components/Feedback/feedback';

import { checkCommunityStatus } from '../../../redux/state/communitySlice.js';

const Created = () => {

    const history = useHistory();
    const dispatch = useDispatch();

    const { communityId } = useParams();

    const [isConfirmed, setIsConfirmed] = useState(false);

    useEffect(() => {
        if (!!communityId) {
            dispatch(checkCommunityStatus(communityId))
                .then(unwrapResult)
                .then(response => setIsConfirmed(response.isConfirmed))
                .catch(({ title }) => toast.info(title));
        }
    }, [communityId, dispatch])

    useEffect(() => {
        if (isConfirmed && !!communityId) {
            history.push(`/communities/community/${communityId}`);
        }
    }, [isConfirmed, communityId, history, dispatch])

    const addMemberHandler = useCallback(() => {
        history.push(`/communities/community/${communityId}/add-members`);
    }, [history, communityId])

    return (
        <div className='createdPage menuVersion'>
            <Feedback
                title="Thank you"
                firstDescription='Your community is pending approval.'
                secondDescription="We'll be in touch: check your email to see our confirmation."
                button={{
                    feedbackTitle: 'Add members',
                    feedbackAction: addMemberHandler,
                    disable: !isConfirmed
                }}
                Image={Celebration}
                titleFontSize={24}
            />
        </div>
    )
}

export default Created;